import PropTypes from 'prop-types';
import { loadMicroApp } from 'qiankun';
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { Flex, Loading } from '../components';

let count = 0;

export function MicroAppLoader(props) {
  const { name, entry, componentProps } = props;

  const containerRef = useRef();
  const microApp = useRef();

  const [loading, updateLoading] = useState(false);

  const componentPropsArr = useMemo(() => {
    const keys = Object.keys(componentProps || {});
    const result = [];
    keys.forEach((key) => {
      result.push(componentProps[key]);
    });
    return result;
  }, [componentProps]);

  useEffect(() => {
    count += 1;
    microApp.current = loadMicroApp({
      name: `${name}-${count}`,
      entry: `${entry}?q=${Date.now()}`,
      container: containerRef.current,
      props: componentProps,
    });
    if (microApp.current.mountPromise) {
      (async () => {
        updateLoading(true);
        try {
          await microApp.current.mountPromise;
        } catch (e) {
          console.error(e);
        }
        updateLoading(false);
      })();
    }

    return () => {
      if (microApp.current) {
        microApp.current.unmount();
        microApp.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (microApp.current && microApp.current.update) {
      microApp.current.update(componentProps);
    }
  }, componentPropsArr);

  return (
    <>
      <div
        ref={containerRef}
        style={{
          width: '100%', height: '100%',
        }}
      />
      {
        loading ? (
          <Flex>
            <Loading className="spinner spinner-blue" />
          </Flex>
        ) : null
      }
    </>
  );
}

MicroAppLoader.defaultProps = {
  componentProps: {},
};

MicroAppLoader.propTypes = {
  name: PropTypes.string.isRequired,
  entry: PropTypes.string.isRequired,
  componentProps: PropTypes.shape(),
};

export default MicroAppLoader;
